// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-icon[data-v-5c64209e]{margin-right:14px;color:var(--q4s-neutral-500)}.header-arrow[data-v-5c64209e]{margin-left:auto;transition:transform .3s ease}.header-arrow[data-v-5c64209e]:not(.collapsed){transform:rotate(180deg)}.header-title[data-v-5c64209e]{font-size:20px}", ""]);
// Exports
module.exports = exports;
